<template>
  <b-form-group :label="item.field.prompt">
    <date-picker id="start-date" v-model="date" style="width:100%" lang="en" format="DD/MM/YYYY" :disabled="item.disabled" :required="item.field.mandatory" :state="isValid"></date-picker>
    <b-form-invalid-feedback :state="isValid">{{errorMessage}}</b-form-invalid-feedback>
  </b-form-group>
</template>


<script>
import moment from 'moment'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'DateField',
  components: { DatePicker },
  props: {
    item: { type: Object }
  },
  data () {
    return {
      isValid: null,
      errorMessage: '',
      date: (this.item.value != null && this.item.value.length > 0 ? moment(this.item.value, 'Y-M-D') : null)
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    validate () {
      this.isValid = true
      this.errorMessage = ''
      if (this.item.field.mandatory && this.date == null) {
        this.isValid = false
        this.errorMessage = 'Please complete'
      }
      if (this.date != null && !this.item.field.allow_future && moment(this.date).isAfter(moment())) {
        this.isValid = false
        this.errorMessage = 'Please choose a date in the past'
      }
      if (this.date != null && !this.item.field.allow_past && moment(this.date).isBefore(moment())) {
        this.isValid = false
        this.errorMessage = 'Please choose a date in the future'
      }
      return this.isValid
    },
    value () {
      const stringValue = (this.date != null ? moment(this.date).format('Y-M-D') : null)
      return { field_name: this.item.field.field_name, string_value: stringValue }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/data_entry/DateField.vue